import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiHelper } from "../../../helpers/apihelper";
import { AuthService } from "../../../services/authservice";
import { BaseProblem, DialogReportProblemComponent } from "../dialog-report-problem/dialog-report-problem";

interface DomainsProblem extends BaseProblem {
  type: string;
  specificObject: string;
}

@Component({
  selector: "dialog-domain-report-problem",
  templateUrl: "./dialog-domain-report-problem.html",
  styleUrls: [
    "../dialog-domain-add/dialog-domain-add.scss",
    "../dialog-domain-add/options/domain-option-available/domain-option-available.scss",
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, FormsModule, AngularSvgIconModule, DialogReportProblemComponent],
})
export class DialogDomainReportProblemComponent {
  private readonly auth = inject(AuthService);
  private readonly api = inject(ApiHelper);

  protected issueType = signal("domain");
  protected specificObject = signal("");
  protected ISSUE_TYPES = [
    { value: "domain", labelKey: "Domains.ReportIssue.IssueType.domain" },
    { value: "reverse_zone", labelKey: "Domains.ReportIssue.IssueType.reverse_zone" },
    { value: "contact", labelKey: "Domains.ReportIssue.IssueType.contact" },
    { value: "nameserver", labelKey: "Domains.ReportIssue.IssueType.nameserver" },
    { value: "zone_template", labelKey: "Domains.ReportIssue.IssueType.zone_template" },
    { value: "other", labelKey: "Domains.ReportIssue.IssueType.other" },
  ];

  protected isResultState = signal(false);
  protected isErrorState = signal(false);

  protected issueTypeIs(t: string): boolean {
    return this.issueType() === t;
  }

  protected submit(base: BaseProblem) {
    const issue: DomainsProblem = {
      ...base,
      type: this.issueType(),
      specificObject: this.specificObject(),
    };

    this.api
      .reportIncidentDomeinen(issue, this.auth.viewingCustomer().customerId)
      .then(() => {
        // success state
        this.isErrorState.set(false);
      })
      .catch((err) => {
        // error state
        console.error(err);
        this.isErrorState.set(true);
      })
      .finally(() => {
        this.isResultState.set(true);
      });
  }
}
